module.exports = __webpack_public_path__ + "media/images/favicons/favicon-16x16-520927b2dc66cca6facefd92392b27a9.png";